import React, { useState, useEffect } from 'react';
import './ReadingProgressBar.css';

const ReadingProgressBar = ({ targetRef }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!targetRef?.current) return;

      const element = targetRef.current;
      const elementTop = element.offsetTop;
      const elementHeight = element.offsetHeight;
      const windowHeight = window.innerHeight;

      // Calculate how much of the article has been scrolled
      const scrolled = window.scrollY - elementTop + windowHeight;
      const total = elementHeight + windowHeight;

      let calculatedProgress = Math.max(0, Math.min(100, (scrolled / total) * 100));
      setProgress(calculatedProgress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [targetRef]);

  return (
    <div className="reading-progress-bar">
      <div 
        className="progress-fill" 
        style={{ width: `${progress}%` }}
        role="progressbar"
        aria-valuenow={Math.round(progress)}
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
  );
};

export default ReadingProgressBar;
